import { useCookies } from 'react-cookie';
import { useFeatureCookieName } from '../useFeatureCookieName';
/**
 * A hook to toggle a feature flag.
 *
 * > Note 1: Uses a cookie to "remember" that setting.
 *
 * > Note 2: This **does not** do API feature flagging.
 */
export const useEnableUrlFeatureFlag = (featureName) => {
    const [_, setCookie] = useCookies();
    /** The name of the cookie this feature will be stored in. */
    const featureCookieName = useFeatureCookieName(featureName);
    return (enabled) => {
        setCookie(featureCookieName, enabled ? 'true' : 'false', { path: '/' });
    };
};
